import * as React from 'react';
import useLabelTranslation from 'src/hooks/useLabelTranslation';

import type {RowData} from './helper';

import {BasicSingleCell} from '@spaced-out/ui-design-system/lib/components/Table';
import {Button} from '@spaced-out/ui-design-system/lib/components/Button';
import {ButtonDropdown} from '@spaced-out/ui-design-system/lib/components/ButtonDropdown';

import {
  getConnectCalendarOptions,
  getNormalizedServiceAccountProvider,
} from './helper';

import css from './calendar-sync.css';


const CalendarConnectionButton = ({data}: RowData) => {
  const {t} = useLabelTranslation();
  const {
    connected,
    onConnect,
    onDisconnect,
    isConnecting,
    isDisconnecting,
    isConnectionLimitReached,
    isVirtualCalendarEnabled,
    serviceAccountProvider,
  } = data || {};

  const handleConnectCalendarWithoutVirtualCalendar = () => {
    const normalizedProvider = getNormalizedServiceAccountProvider(
      serviceAccountProvider,
    );
    onConnect(normalizedProvider);
  };

  if (connected) {
    return (
      <BasicSingleCell className={css.disconnectButton}>
        <Button
          size="small"
          type="tertiary"
          isLoading={isDisconnecting}
          onClick={onDisconnect}
        >
          {t('Disconnect', 'Disconnect')}
        </Button>
      </BasicSingleCell>
    );
  }

  return (
    <BasicSingleCell className={css.connectButton}>
      {!connected &&
        (isVirtualCalendarEnabled ? (
          <ButtonDropdown
            size="small"
            type="secondary"
            anchorPosition="bottom-end"
            positionStrategy="fixed"
            menu={{
              isFluid: false,
              options: getConnectCalendarOptions({
                t,
                showCount: false,
                serviceAccountProvider,
              }),
              size: 'small',
            }}
            isLoading={isConnecting}
            disabled={isConnectionLimitReached}
            onOptionSelect={(option) => onConnect(option.key)}
          >
            {t('Connect', 'Connect')}
          </ButtonDropdown>
        ) : (
          <Button
            size="small"
            isLoading={isConnecting}
            onClick={handleConnectCalendarWithoutVirtualCalendar}
            type="secondary"
            disabled={isConnectionLimitReached}
          >
            {t('Connect', 'Connect')}
          </Button>
        ))}
    </BasicSingleCell>
  );
};

export default CalendarConnectionButton;
